const config={

  "columns":[
    {"title":"Documentation","rows":[
      
      {"title":"Contract Code","url":"https://etherscan.io/address/0x0a59f69075b0c17a57c208471d0adb99ff368471#code"},
    
    ]},
    {"title":"Community & Social","rows":[
      {"title":"Discord","url":"https://discord.com/invite/wgst7qM5n3"},
      
    ]},
    {"title":"Fun & Learning","rows":[
      {"title":"Coming soon","url":""},
       
    ]} 
  ]

}
export default config;

 